/**
 * Auth cookie options for Orbyt member hosts.
 * Production: shared across *.orbyt.app so a live session can short-circuit login.
 * Local/dev: host-only (ports differ; Domain=.localhost is unreliable).
 */
export function authCookieOptions(): {
  domain?: string
  path: string
  sameSite: 'lax'
  maxAge: number
} {
  const isProd =
    process.env.NODE_ENV === 'production' ||
    process.env.NEXT_PUBLIC_COOKIE_DOMAIN === '.orbyt.app'

  return {
    ...(isProd ? { domain: '.orbyt.app' } : {}),
    path: '/',
    sameSite: 'lax',
    // Long-lived — weekly mobile openers should not re-auth every visit.
    maxAge: 60 * 60 * 24 * 400,
  }
}
